/**
 * @format
 */

import React from 'react';
import {
  Dimensions,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import ThumbtackCategoryItem from '../../../ThumbtackCategoryItem';

const debug = require('debug')('se:advertitem');

const { width: windowWidth } = Dimensions.get('window');

import ExploreImage from '../../../../components/ZTImage';
import {
  // ThumbtackCategoriesObject,
  ThumbtackHomecare,
} from '../../../../api/adserver';
import config from '../../../../lib/config';

export interface Props {
  // category: ThumbtackHomecare | ThumbtackCategoriesObject;
  category: ThumbtackHomecare;
  // onPress: (item: ThumbtackCategoriesObject | ThumbtackHomecare) => void;
  onPress: (item: ThumbtackHomecare) => void;
  hideText?: boolean;
  margin?: number;
}

const ThumbtackCategoryListItem: React.FC<Props> = ({ category, onPress }) => {
  const handleOnPress = () => {
    onPress(category);
  };

  return (
    <View style={styles.container}>
      <TouchableOpacity onPress={handleOnPress}>
        <ThumbtackCategoryItem
          uri={category.imageURL}
          imageStyle={styles.mainImage}
          categoryName={category.categoryDisplayName}
          categoryDescription={category.taskDetails.description}
        />
      </TouchableOpacity>
    </View>
  );
};

const widthFeaturePadding = 8;
const itemFeatureWidth = windowWidth - (21 + widthFeaturePadding);
const featureItemHeight =
  itemFeatureWidth * config.theme.advert.imageHeightRatio;
const totalFeatureItemWidth = itemFeatureWidth + widthFeaturePadding;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginTop: 15,
  },
  headingsDetailContainer: {
    marginTop: 15,
  },
  slideFeatureContainer: {
    height: featureItemHeight,
    width: totalFeatureItemWidth,
    margin: 0,
  },
  mainImage: {
    width: itemFeatureWidth,
    height: featureItemHeight,
    borderRadius: 0,
    borderWidth: config.theme.carousel.imageBorder,
    borderColor: config.theme.carousel.imageBorderColor,
  },
  detailText: {
    fontSize: 13,
    color: config.theme.advert.subSectionHeadingTextColor,
  },
  bottomMargin1Em: {
    marginBottom: 14,
  },
  featureHeading: {
    fontSize: config.theme.headingFontSize,
    fontWeight: config.theme.headingFontWeight,
    color: config.theme.headingTextColor,
    marginBottom: 10,
  },
});

export default ThumbtackCategoryListItem;
